import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Command from '@ckeditor/ckeditor5-core/src/command';

import AnchorIcon from '../icons/anchor.svg';
import './anchor-id.css';

export default class AnchorIdPlugin extends Plugin {

  static get pluginName() {
    return 'AnchorId';
  }

  init() {
    const editor = this.editor;

    //
    // 1) Регистрируем команду вручную (ОБЯЗАТЕЛЬНО!)
    //
    editor.commands.add('anchorId', new AnchorIdCommand(editor));

    //
    // 2) Разрешаем id на блоках
    //
    /*
    [
      'paragraph',
      'heading1',
      'heading2',
      'heading3'
    ].forEach(name => {
      editor.model.schema.extend(name, { allowAttributes: ['id'] });
    });
    */

    // 2) Разрешаем id абсолютно на ВСЕХ элементах модели
    const schema = editor.model.schema;
    const definitions = schema.getDefinitions();

    for (const name of Object.keys(definitions)) {
      schema.extend(name, { allowAttributes: ['id'] });
    }

    //
    // 3) Модель → HTML
    //
    /*
    editor.conversion.for('downcast').attributeToAttribute({
      model: 'id',
      view: 'id'
    });
    */
    editor.conversion.for('downcast').add(dispatcher => {
      dispatcher.on('attribute:id', (evt, data, api) => {
        const viewWriter = api.writer;
        const viewElement = api.mapper.toViewElement(data.item);

        if (!viewElement) return;

        if (data.attributeNewValue) {
          // Ставим id
          viewWriter.setAttribute('id', data.attributeNewValue, viewElement);

          // Ставим класс
          viewWriter.addClass('has-anchor-id', viewElement);

          // Ставим data-anchor-id, чтобы CSS мог вывести его
          viewWriter.setAttribute('data-anchor-id', data.attributeNewValue, viewElement);

        } else {
          viewWriter.removeAttribute('id', viewElement);
          viewWriter.removeClass('has-anchor-id', viewElement);
          viewWriter.removeAttribute('data-anchor-id', viewElement);
        }
      });
    });

    //
    // 4) HTML → Модель
    //
    editor.conversion.for('upcast').attributeToAttribute({
      view: 'id',
      model: 'id'
    });

    //
    // 5) Кнопка
    //
    editor.ui.componentFactory.add('anchorId', locale => {
      const button = new ButtonView(locale);
      const command = editor.commands.get('anchorId');

      button.set({
        label: 'Якорь',
        tooltip: true,
        withText: false,
        icon: AnchorIcon
      });

      // Подсветка кнопки, если текущий элемент имеет id
      button.bind('isOn').to(command, 'value', value => !!value);

      button.on('execute', () => {
        const currentId = command.value || '';
        const newId = prompt('Введите ID:', currentId);

        if (newId !== null) {
          // OK (не Cancel)
          editor.execute('anchorId', { value: newId });
        }
      });

      return button;
    });
  }
}

class AnchorIdCommand extends Command {

  refresh() {
    const editor = this.editor;
    const selection = editor.model.document.selection;

    // Получаем текущий элемент
    const element =
      selection.getSelectedElement() ||
      selection.getFirstPosition().parent;

    // Значение команды = текущий id или null
    this.value = element.getAttribute('id') || null;

    // Команда всегда доступна
    this.isEnabled = true;
  }

  execute({ value }) {
    const editor = this.editor;

    editor.model.change(writer => {
      const selection = editor.model.document.selection;
      const element =
        selection.getSelectedElement() ||
        selection.getFirstPosition().parent;

      if (value) {
        writer.setAttribute('id', value, element);
      } else {
        writer.removeAttribute('id', element);
      }
    });
  }
}
